import React from 'react';
import Spinner from '@/components/ui/Spinner';

interface LoadingWrapperProps {
  loading: boolean;
  children: React.ReactNode;
  minHeight?: string;
  loadingText?: string;
  className?: string;
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
    loading,
    children,
    minHeight = '400px',
    loadingText,
    className = ''
}) => {
    if (loading) {
        return (
            <div 
                className={`loading-wrapper ${className}`}
                style={{minHeight}}
            >
                <Spinner 
                    size="md"
                    text={loadingText}
                    textPosition="above"
                    centered
                    minHeight={minHeight}
                />
            </div>
        );
    }

    return (
        <div className={`content-wrapper ${className}`} style={{minHeight}}>
            {children}
        </div>
    );
};

export default LoadingWrapper;
